import { useQuery } from 'react-query';
import { FragaProductByPlateRequest, FragaProductRequest } from './Fraga.types';
import FragaServices from './Fraga.services';
import notificationError from '@/utils/functions/notificationError';

export function useFragaProductsByPlate(params?: FragaProductByPlateRequest) {
  return useQuery(
    ['fraga/plate', { ...params }],
    () => FragaServices.productsByPlate(params),
    {
      enabled: !!params?.plate,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useFragaProducts(params?: FragaProductRequest) {
  return useQuery(
    ['fraga/products', { ...params }],
    () => FragaServices.products(params),
    {
      enabled: !!params?.query,
      onError(err) {
        notificationError(err);
      },
    },
  );
}
